import * as Yup from 'yup';

import { AlertEnum, ButtonTypeEnum } from '../../enums';
import { Button, DefaultCard, TextField } from '../../components';
import { Form, Formik } from 'formik';
import { useAlert, useAuthAxios, useErrorHandler } from '../../hooks';

import { ApiHelper } from '../../helpers';
import { CargoFormType } from '../../types';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

const CargoSchema = (t: Function) =>
  Yup.object().shape({
    nome: Yup.string().required(t('validacao.campo_obrigatorio')),
  });

const initialValues = {
  nome: '',
};

const CargoForm: FunctionComponent<CargoFormType> = ({ idEleicao, cargos, setCargos, cargoAlteracao, setCargoAlteracao }) => {
  const { t } = useTranslation();
  const axios = useAuthAxios();
  const { createAlert } = useAlert();
  const errorHandler = useErrorHandler();
  const isAlteracao = !!cargoAlteracao?.id;

  return (
    <Formik
      initialValues={{ ...initialValues, ...cargoAlteracao }}
      enableReinitialize
      validationSchema={CargoSchema(t)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        axios({
          data: values,
          method: isAlteracao ? 'put' : 'post',
          url: isAlteracao
            ? ApiHelper.getUrl.apiSCE.cargo(idEleicao, cargoAlteracao.id)
            : ApiHelper.getUrl.apiSCE.cargos(idEleicao),
        })
          .then((response) => {
            createAlert(t(`sucesso.${isAlteracao ? 'alterar' : 'cadastrar'}_cargo`), AlertEnum.SUCCESS);
            if (isAlteracao) {
              const indexAlteracao = cargos.findIndex((cargo) => cargo.id === cargoAlteracao.id);
              cargos.splice(indexAlteracao, 1, response.data);
              setCargoAlteracao(null);
            } else {
              setCargos([...cargos, response.data]);
              resetForm();
            }
          })
          .catch((error) => errorHandler(error, t(`erro.${isAlteracao ? 'alterar' : 'cadastrar'}_cargo`)))
          .finally(() => {
            setSubmitting(false);
          });
      }}
    >
      {(props) => (
        <Form>
          <DefaultCard
            cardTitle={t('label.adicionar_novo_cargo')}
            helpLink={
              'https://conhecimento.sti.ufpb.br/books/sistema-de-cadastro-de-eleicoes/page/gerenciar-os-cargos-e-candidaturas'
            }
            footer={
              <div className="d-flex justify-content-center gap-5">
                {isAlteracao && (
                  <Button
                    title={t('label.cancelar')}
                    disabled={props.isSubmitting || props.isValidating}
                    onClick={() => setCargoAlteracao(null)}
                    outline
                  />
                )}
                <Button
                  title={t(`label.${isAlteracao ? 'alterar' : 'adicionar'}`)}
                  type={ButtonTypeEnum.SUBMIT}
                  disabled={props.isSubmitting || props.isValidating}
                />
              </div>
            }
          >
            <TextField formikProps={props} name="nome" label={t('label.nome_cargo')} required maxLength={100} />
          </DefaultCard>
        </Form>
      )}
    </Formik>
  );
};

export default CargoForm;
